import { Ticker } from "pixi.js";
import { ICollidable } from "./ICollidable";

class PhysicsEngine {
    private collidables: Array<ICollidable>;

    public constructor(private readonly initialCollectionSize: number = 20) {
        this.collidables = new Array(initialCollectionSize);
        Ticker.shared.add(this.update, this);
    }

    public add(object: ICollidable): void {
        // Find free space in array to insert new element
        const freeIndex = this.collidables.findIndex((value) => value == null);
        if (freeIndex != -1) {
            this.collidables[freeIndex] = object;
            return;
        }
        // No free space in array so expand array with new element
        this.collidables.push(object);
    }

    public remove(object: ICollidable): void {
        const objectIndex = this.collidables.findIndex((value) => value == object);
        if (objectIndex == -1) {
            console.warn("You are trying to remove non-existent collidable");
            return;
        }
        this.collidables[objectIndex] = null;
    }

    public removeAll(): void {
        this.collidables = new Array(this.initialCollectionSize);
    }

    private update(dt: number): void {
        this.checkCollisions();
    }

    private checkCollisions(): void {
        for (let i = 0; i < this.collidables.length - 1; i++) {
            const object = this.collidables[i];
            // Skip empty
            if (object == null) {
                continue;
            }
            for (let j = i + 1; j < this.collidables.length; j++) {
                const otherObject = this.collidables[j];
                // Skip empty
                if (otherObject == null) {
                    continue;
                }
                if (object.boundingBox.intersectsBox(otherObject.boundingBox)
                    && object.collidesWithLayer & otherObject.collidesWithLayer
                ) {
                    object.onCollision?.(otherObject);
                    otherObject.onCollision?.(object);
                }
            }
        }
    }
}

export const Physics = new PhysicsEngine();